import { MenuItem } from '../../types/MenuItem.type'

/**
 * Build analytics label based on the index path.
 * Tier1 → "Tier1"
 * Tier2 → "Tier1 | Tier2"
 * Tier3 → "Tier1 | Tier2 | Tier3"
 */
export const getAnalyticsLabel = (
  menuItems: MenuItem[],
  t1?: number,
  t2?: number,
  t3?: number
) => {
  if (t1 == null) return ''

  const tier1 = menuItems[t1]?.name
  if (t2 == null) return tier1

  const tier2 = menuItems[t1]?.menuItems?.[t2]?.name
  if (t3 == null) return `${tier1} | ${tier2}`

  const tier3 = menuItems[t1]?.menuItems?.[t2]?.menuItems?.[t3]?.name
  return `${tier1} | ${tier2} | ${tier3}`
}
